import { render, staticRenderFns } from "./CloudinaryImg.vue?vue&type=template&id=3c3b874a&"
import script from "./CloudinaryImg.vue?vue&type=script&lang=js&"
export * from "./CloudinaryImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260420081713/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3b874a')) {
      api.createRecord('3c3b874a', component.options)
    } else {
      api.reload('3c3b874a', component.options)
    }
    module.hot.accept("./CloudinaryImg.vue?vue&type=template&id=3c3b874a&", function () {
      api.rerender('3c3b874a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/helpers/components/CloudinaryImg.vue"
export default component.exports